// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6638":"0375fe50","8018":"4cd10c4f","9240":"c0a9dc86"}[chunkId] + ".chunk.css";
};